import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { clearChunkReloadFlag } from "@/routes/lazyPage";
import { initSentry } from "@/lib/monitoring/sentry";

clearChunkReloadFlag();
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
